import React from 'react'

import { observer } from 'mobx-react'

import { ActionConfigurationIdentifiers, type Item } from 'modules/processes/domain'

import SurveyRemoved from './SurveyRemoved'

interface Props {
  item: Item
}

const LinkedConfigurationRemoved = ({ item }: Props) => {
  const configuration = item.configuration ? JSON.parse(item.configuration) : {}

  switch (item.configurationIdentifier) {
    case ActionConfigurationIdentifiers.SendSurvey:
      return <SurveyRemoved surveyId={configuration?.survey_id} />
    default:
      return <></>
  }
}

export default observer(LinkedConfigurationRemoved)
